"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var loadUserInfo = function loadUserInfo(payload) {
  var _ref = payload || {},
      userId = _ref.userId,
      clientId = _ref.clientId,
      withGroup = _ref.withGroup;

  return {
    type: 'OLY_LOAD_USER_INFO',
    payload: {
      userId: userId,
      clientId: clientId,
      withGroup: withGroup
    }
  };
};

var loadUserInfoSuccess = function loadUserInfoSuccess(userInfo) {
  return {
    type: 'OLY_LOAD_USER_INFO_SUCCESS',
    payload: {
      userInfo: userInfo
    }
  };
};

var loadUserInfoError = function loadUserInfoError(error) {
  return {
    type: 'OLY_LOAD_USER_INFO_ERROR',
    payload: {
      error: error
    }
  };
};

var loadUserInfoReset = function loadUserInfoReset() {
  return {
    type: 'OLY_LOAD_USER_INFO_RESET'
  };
};

var editUserInfo = function editUserInfo(payload) {
  return {
    type: 'OLY_EDIT_USER_INFO',
    payload: payload
  };
};

var editUserInfoSuccess = function editUserInfoSuccess(editedUserId) {
  return {
    type: 'OLY_EDIT_USER_INFO_SUCCESS',
    payload: {
      editedUserId: editedUserId
    }
  };
};

var editUserInfoError = function editUserInfoError(error) {
  return {
    type: 'OLY_EDIT_USER_INFO_ERROR',
    payload: {
      error: error
    }
  };
};

var editUserInfoReset = function editUserInfoReset() {
  return {
    type: 'OLY_EDIT_USER_INFO_RESET'
  };
};

var editUserClient = function editUserClient(payload) {
  return {
    type: 'OLY_EDIT_USER_CLIENT',
    payload: payload
  };
};

var editUserClientSuccess = function editUserClientSuccess() {
  return {
    type: 'OLY_EDIT_USER_CLIENT_SUCCESS'
  };
};

var editUserClientError = function editUserClientError(error) {
  return {
    type: 'OLY_EDIT_USER_CLIENT_ERROR',
    payload: {
      error: error
    }
  };
};

var editUserClientReset = function editUserClientReset() {
  return {
    type: 'OLY_EDIT_USER_CLIENT_RESET'
  };
};

var deleteUserInfoGroup = function deleteUserInfoGroup(payload) {
  return {
    type: 'OLY_DELETE_USER_INFO_GROUP',
    payload: payload
  };
};

var deleteUserInfoGroupSuccess = function deleteUserInfoGroupSuccess(deletedUserGroupId) {
  return {
    type: 'OLY_DELETE_USER_INFO_GROUP_SUCCESS',
    payload: {
      deletedUserGroupId: deletedUserGroupId
    }
  };
};

var deleteUserInfoGroupError = function deleteUserInfoGroupError(error) {
  return {
    type: 'OLY_DELETE_USER_INFO_GROUP_ERROR',
    payload: {
      error: error
    }
  };
};

var deleteUserInfoGroupReset = function deleteUserInfoGroupReset() {
  return {
    type: 'OLY_DELETE_USER_INFO_GROUP_RESET'
  };
};

var deleteUserInfoClient = function deleteUserInfoClient(payload) {
  return {
    type: 'OLY_DELETE_USER_INFO_CLIENT',
    payload: payload
  };
};

var deleteUserInfoClientSuccess = function deleteUserInfoClientSuccess(deletedUserClientId) {
  return {
    type: 'OLY_DELETE_USER_INFO_CLIENT_SUCCESS',
    payload: {
      deletedUserClientId: deletedUserClientId
    }
  };
};

var deleteUserInfoClientError = function deleteUserInfoClientError(error) {
  return {
    type: 'OLY_DELETE_USER_INFO_CLIENT_ERROR',
    payload: {
      error: error
    }
  };
};

var deleteUserInfoClientReset = function deleteUserInfoClientReset() {
  return {
    type: 'OLY_DELETE_USER_INFO_CLIENT_RESET'
  };
};

var deleteUser = function deleteUser(payload) {
  return {
    type: 'OLY_DELETE_USER',
    payload: payload
  };
};

var deleteUserSuccess = function deleteUserSuccess(deletedUserId) {
  return {
    type: 'OLY_DELETE_USER_SUCCESS',
    payload: {
      deletedUserId: deletedUserId
    }
  };
};

var deleteUserError = function deleteUserError(error) {
  return {
    type: 'OLY_DELETE_USER_ERROR',
    payload: {
      error: error
    }
  };
};

var deleteUserReset = function deleteUserReset() {
  return {
    type: 'OLY_DELETE_USER_RESET'
  };
};

var _default = {
  loadUserInfo: loadUserInfo,
  loadUserInfoSuccess: loadUserInfoSuccess,
  loadUserInfoError: loadUserInfoError,
  loadUserInfoReset: loadUserInfoReset,
  editUserInfo: editUserInfo,
  editUserInfoSuccess: editUserInfoSuccess,
  editUserInfoError: editUserInfoError,
  editUserInfoReset: editUserInfoReset,
  editUserClient: editUserClient,
  editUserClientSuccess: editUserClientSuccess,
  editUserClientError: editUserClientError,
  editUserClientReset: editUserClientReset,
  deleteUserInfoGroup: deleteUserInfoGroup,
  deleteUserInfoGroupSuccess: deleteUserInfoGroupSuccess,
  deleteUserInfoGroupError: deleteUserInfoGroupError,
  deleteUserInfoGroupReset: deleteUserInfoGroupReset,
  deleteUserInfoClient: deleteUserInfoClient,
  deleteUserInfoClientSuccess: deleteUserInfoClientSuccess,
  deleteUserInfoClientError: deleteUserInfoClientError,
  deleteUserInfoClientReset: deleteUserInfoClientReset,
  deleteUser: deleteUser,
  deleteUserSuccess: deleteUserSuccess,
  deleteUserError: deleteUserError,
  deleteUserReset: deleteUserReset
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map